<script setup lang="ts">
import { computed } from 'vue';
interface Props {
    title?: string;
    subtitle?: string;
    image?: string; // background image URL
}

const props = defineProps<Props>();

const bannerStyle = computed(() => {
    return props.image ? { backgroundImage: `url('${props.image}')` } : {};
});
</script>
<template>
    <div class="fs-banner" :style="bannerStyle">
        <v-container>
            <div class="fs-banner-content">
                <div class="fs-banner-title">
                    <h1 v-if="props.title">{{ props.title }}</h1>
                    <p v-if="props.subtitle">{{ props.subtitle }}</p>
                </div>
            </div>
        </v-container>
    </div>
</template>
